import React from "react";
import styled from "styled-components";
import { PAinfoCollapsible } from "../uikit2";

import {
  FormGroup,
} from "xsolla-uikit";




export const PArefundHintText = ({
  opened = true
 }) => {
  return (<CssInfoGrid>
    <FormGroup
      indentation="sm"
      // label="What is Fast&Fair Refunds?"
    >
      Fast&Fair Refunds™ includes an intuitive refund process, designed to help you resolve any payment-related questions or issues in a timely and transparent manner. (This text is DRAFT)
    </FormGroup>

    <FormGroup indentation="sm" label="See also:">
      <ul>
        <li>
          Case study:{" "}
          <a href="">
            Tarkov changed refund policy and earned gamers'
            appreciation around the world
          </a>
        </li>
        <li>
          White paper: <a href="">Best practices of refunds</a>
        </li>
        <li>
          <a href="/">How refund policy affects user loyalty</a>
        </li>
      </ul>
    </FormGroup>
  </CssInfoGrid>);
};



export const PArefundHint = ({
  opened = true
 }) => {
  return (<FormGroup indentation="lg">
  <PAinfoCollapsible
    isOpen={opened}
    title="Refund policy configuration tips"
  >
    {/* <PAh2 tag="h4" title="Refund policy configuration tips" /> */}

    <FormGroup indentation="lg">
      <PArefundHintText/>
    </FormGroup>
  </PAinfoCollapsible>
</FormGroup>);
};



const CssInfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 24px;
`;


